import React, { useEffect, useState } from 'react';
import { CreateExtComponent } from '@powerednow/client-shared/Components/react/React';
import MappingTree from '@powerednow/components/MappingTree/MappingTree';
import { DataWrapper, getDataWrapper } from 'FieldServices/singletons/DataWrapper';

import withDataWrapper from 'FieldServices/hooks/withDataWrapper';
import Box from '@powerednow/components/Box/Box';
import Typography from '@mui/material/Typography';
import { useProductCategoryTree, useXeroIntegrationSettings } from './hooks';
import CategorySelector from './CategorySelector';

declare let AuthManager: any;
declare let handleClientError: any;

const saveMapping = async (integrationId, mapping) => {
    if (!integrationId) {
        return;
    }
    const dataWrapper: DataWrapper = getDataWrapper();
    const integration = await dataWrapper.getComplexDataObject('CompanyIntegration', integrationId);
    const settings = structuredClone(integration.data.settings);
    settings.productCategoryMapping = mapping;
    integration.data.settings = settings;
    await dataWrapper.saveComplexDataObject(integration);
};

function CategoriesMap() {
    const { loaded, categoryTree } = useProductCategoryTree(AuthManager.getCompanyId());

    const {
        loaded: integrationSettingsLoaded,
        xeroIntegration,
    } = useXeroIntegrationSettings(AuthManager.getCompanyId());

    const [mapping, setMapping] = useState({});

    const handleChange = (newMapping: { [key: string]: { salesCode: string, costCode: string } }) => {
        if (!newMapping) {
            return;
        }
        const filteredMapping = Object.entries(newMapping).reduce((acc, [key, value]) => {
            if (value.salesCode || value.costCode) {
                acc[key] = value;
            }
            return acc;
        }, {});
        saveMapping(xeroIntegration.id, filteredMapping).catch(handleClientError);
        setMapping(filteredMapping);
    };
    useEffect(() => {
        setMapping(xeroIntegration?.settings?.productCategoryMapping);
    }, [xeroIntegration?.settings?.productCategoryMapping]);

    if (!loaded || !integrationSettingsLoaded) {
        return <div>Loading category maps...</div>;
    }

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row-reverse', mb: 2 }}>
                <Typography
                    fontWeight={800}
                    component="span"
                    sx={{
                        width: 'min(max(100px, 25vw), 400px)',
                        mr: 0,
                    }}
                >
                    Cost
                </Typography>
                <Typography fontWeight={800} component="span" sx={{ width: 'min(max(100px, 25vw), 400px)', mr: 5 }}>Sales</Typography>
            </Box>
            <MappingTree
                displayField="name"
                tree={categoryTree}
                mapping={mapping}
                slots={{
                    editContent: CategorySelector,
                }}
                slotProps={{
                    editContent: {
                        xeroIntegration,
                    },
                }}
                onChange={handleChange}
            />
        </>
    );
}

export default CategoriesMap;

export const ExtCategoriesMap = CreateExtComponent(
    'FieldServices.widgets.accounting.integration.xero.configuration.CategoriesMap',
    withDataWrapper(CategoriesMap),
    {
        alias: 'widget.ExtCategoriesMap',
    },
);
